export const SetSession = 'SetSession';
export const TokenReflesh = 'TokenReflesh';
export const RefleshToken = 'RefleshToken';
export const GetMembers = 'GetMembers';
export const SendMessage = 'SendMessage';